import api from "../../Environment";

/**
 * Phase B donation engine client.
 */

export async function fetchDonationCatalog() {
  try {
    const response = await api.postMethod("donations/catalog", {});
    const body = response && response.data;
    if (body && body.success) {
      return body.data;
    }
  } catch (e) {
    /* ignore */
  }
  return null;
}

export async function fetchDonationTarget(targetType, targetId) {
  try {
    const response = await api.postMethod("donations/target", {
      target_type: targetType,
      target_id: targetId,
    });
    const body = response && response.data;
    if (body && body.success) {
      return body.data;
    }
  } catch (e) {
    /* ignore */
  }
  return null;
}

export async function fetchDonationHistory(targetType, targetId, take = 20) {
  try {
    const response = await api.postMethod("donations/history", {
      target_type: targetType,
      target_id: targetId,
      take,
    });
    const body = response && response.data;
    if (body && body.success) {
      return body.data;
    }
  } catch (e) {
    /* ignore */
  }
  return { items: [], total: 0 };
}
